import React from 'react';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import {panelEnabled} from '../../lib/robot-connect.js';

/**
 * 메뉴바 글자(2026-10-01, 10-06 바꿈) — '블록 연결하기'로 고정.
 *   10-01 에는 "🔌 그룹 0012"처럼 번호를 보여 줬는데, 직원 의견(10-06): 연결 창을 닫으면 글자가 바뀌어 헷갈리고
 *   그 아이콘(🔌)이 PC 에 따라 이상하게 보임 → 늘 같은 글자. 번호는 창 맨 위에서 확인한다.
 *   한국어/영어만 새 글자(이 창의 문구가 ko/en 인라인이라 맞춤). 다른 언어는 예전 번역 글자("그룹 번호 설정" 번역)를 그대로 쓴다.
 *   되돌리기 스위치(curoai_robot_panel=0)가 꺼져 있으면 예전 글자.
 */
const GroupLabel = ({intl}) => {
    const loc = (intl && intl.locale) || '';
    if (panelEnabled() && /^ko/.test(loc)) return <span>{'블록 연결하기'}</span>;
    if (panelEnabled() && /^en/.test(loc)) return <span>{'Connect blocks'}</span>;
    return (
        <FormattedMessage
            defaultMessage="그룹 번호 설정"
            description="그룹 번호 설정"
            id="gui.cubroidGroupNumber.label"
        />
    );
};

GroupLabel.propTypes = {
    intl: intlShape.isRequired
};

export default injectIntl(GroupLabel);
